import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box'
export default function leftView() {
    return (
            <Paper className='left_view' elevation={3} >
            </Paper>
    )
}